class CustomModal extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.handleClick.bind(this));
    }
  
    connectedCallback() {
      this.closeButton = this.querySelector('.custom-modal__close');
      this.overlay = this.querySelector('.custom-modal__overlay');
      
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.hide();
      });
    }
  
    handleClick(event) {
      if (event.target === this.overlay || event.target === this.closeButton) {
        this.hide();
      }
    }
  
    show() {
      this.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
      document.querySelector('main').style.zIndex = '100';
    }
  
    hide() {
      this.removeAttribute('open');
      document.body.style.overflow = '';
      document.querySelector('main').style.zIndex = '2';
      if (this.getAttribute('data-pause-on-close') === 'true') {
        const videoContainer = document.querySelector('.video-container');
        if (videoContainer) {
          while (videoContainer.firstChild) {
            videoContainer.removeChild(videoContainer.firstChild);
          }
        }
      }
    }
  }
  
  class CustomModalOpener extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.handleClick.bind(this));
    }
  
    handleClick(event) {
      event.preventDefault();
      const modalId = this.getAttribute('data-custom-modal-target');
      // console.log('Opening modal:', modalId);
      const modal = document.querySelector(`custom-modal[data-modal-id="${modalId}"]`);
      if (modal) modal.show();
    }
  }
  
  customElements.define('custom-modal', CustomModal);
  customElements.define('custom-modal-opener', CustomModalOpener);